import {
  VStack,
  Text,
  Button,
  Icon,
  Alert,
  AlertIcon,
  Box,
  AlertTitle,
  AlertDescription,
  useDisclosure,
} from "@chakra-ui/react";
import { useAppState } from "../../components/App/AppProvider";
import { hasAccessTo } from "../../shared/_core/limit.utils";
import { RiArrowUpCircleLine } from "react-icons/ri";
import { UpgradeNowModal } from "./UpgradeNowModal";

export function NoAccessLicense() {
  const { app } = useAppState();

  const upgradeNowModalState = useDisclosure({
    defaultIsOpen: false,
  });

  const isAdministrator = app.permissions.ACCOUNT_SETTINGS;
  const canUpgrade = hasAccessTo("upgrade", app.license);

  return (
    <chakra-scope>
      <UpgradeNowModal
        isOpen={upgradeNowModalState.isOpen}
        onClose={upgradeNowModalState.onClose}
      />
      <VStack
        mt="12%"
        w="100%"
        justifyContent="center"
        alignItems="center"
        spacing={6}>
        <Alert maxW="40rem" status="warning">
          <AlertIcon />
          <Box>
            <AlertTitle>
              You don't have access to this CertCrowd feature.
            </AlertTitle>
            {canUpgrade && isAdministrator && (
              <AlertDescription display="block">
                Upgrade now to unlock the Risk module and other features.
              </AlertDescription>
            )}
          </Box>
        </Alert>
        {isAdministrator && canUpgrade && (
          <VStack w="100%">
            <Button
              onClick={upgradeNowModalState.onOpen}
              leftIcon={
                <Icon as={RiArrowUpCircleLine} zIndex={2} boxSize="20px" />
              }>
              Upgrade now
            </Button>
          </VStack>
        )}
      </VStack>
    </chakra-scope>
  );
}
